import axios from "axios";
import { HOST } from "../../setting";
import { tranformToFormData } from "../../utils/common";

export const service = (data) => {
  return axios.post(`${HOST}/master/new-kit/`, tranformToFormData(data));
};
